import script from "./success.vue?vue&type=script&setup=true&lang=ts"
export * from "./success.vue?vue&type=script&setup=true&lang=ts"

import "./success.vue?vue&type=style&index=0&id=488724e8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-488724e8"]])

export default __exports__